import { Link } from "@tanstack/react-router";
import type { User } from "@/hooks/use-users";

/**
 * Which employee an account signs in as.
 *
 * Rendered even when nothing is linked, because that is the state worth
 * seeing: an unlinked account gets an empty My Dashboard, empty My
 * Certifications and no "View as this person" on any profile, and until this
 * column existed there was nowhere in the app that said so.
 */
export function LinkedPerson({ user }: { user: Pick<User, "personId" | "personName"> }) {
  if (!user.personId || !user.personName) {
    return <span className="text-muted-foreground text-xs">Not linked</span>;
  }
  return (
    <Link
      to="/dashboard/persons/$personId"
      params={{ personId: user.personId }}
      className="text-sm text-primary underline decoration-primary/40 underline-offset-2 transition-colors hover:decoration-primary"
    >
      {user.personName}
    </Link>
  );
}
